export default "__VITE_ASSET__DHgP3SaD__"